import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'lib-dynamic-page-element-margin-padding',
  standalone: false,
  templateUrl: './dynamic-page-element-margin-padding.component.html',
  styleUrl: './dynamic-page-element-margin-padding.component.scss'
})
export class DynamicPageElementMarginPaddingComponent {

  @Input() marginTop!: number;
  @Input() marginRight!: number;
  @Input() marginBottom!: number;
  @Input() marginLeft!: number;

  @Input() paddingTop!: number;
  @Input() paddingRight!: number;
  @Input() paddingBottom!: number;
  @Input() paddingLeft!: number;

  // Outputs (two-way binding)
  @Output() marginTopChange = new EventEmitter<number>();
  @Output() marginRightChange = new EventEmitter<number>();
  @Output() marginBottomChange = new EventEmitter<number>();
  @Output() marginLeftChange = new EventEmitter<number>();

  @Output() paddingTopChange = new EventEmitter<number>();
  @Output() paddingRightChange = new EventEmitter<number>();
  @Output() paddingBottomChange = new EventEmitter<number>();
  @Output() paddingLeftChange = new EventEmitter<number>();

   onMarginTopChange(value: number) {
    this.marginTop = value;
    this.marginTopChange.emit(value);
  }

  onMarginRightChange(value: number) {
    this.marginRight = value;
    this.marginRightChange.emit(value);
  }

  onMarginBottomChange(value: number) {
    this.marginBottom = value;
    this.marginBottomChange.emit(value);
  }

  onMarginLeftChange(value: number) {
    this.marginLeft = value;
    this.marginLeftChange.emit(value);
  }

  onPaddingTopChange(value: number) {
    this.paddingTop = value;
    this.paddingTopChange.emit(value);
  }

  onPaddingRightChange(value: number) {
    this.paddingRight = value;
    this.paddingRightChange.emit(value);
  }

  onPaddingBottomChange(value: number) {
    this.paddingBottom = value;
    this.paddingBottomChange.emit(value);
  }

  onPaddingLeftChange(value: number) {
    this.paddingLeft = value;
    this.paddingLeftChange.emit(value);
  }
}
